import { BehavioralPopupConnectLyraStyled } from "./BehavioralPopupConnectLyra.styled";
import Translate from "components/Translate/Translate";

import { FC } from "react";
import { BehavioralPopupConnectLyraWithApi } from "./BehavioralPopupConnectLyraWithApi";
import { CustomDialogHeading } from "molecule/customDialog/CustomDialogHeading";

const {
  ConnectLyraPopup,
  LyraHeader,
  LyraLogo,
  Separator,
  NineAmLogo,
  Wrapper,
  Description,
  Action
} = BehavioralPopupConnectLyraStyled;

export const BehavioralPopupConnectLyra: FC = () => {
  return (
    <ConnectLyraPopup isDismissable={true}>
      <LyraHeader>
        <LyraLogo />
        <Separator />
        <NineAmLogo />
      </LyraHeader>
      <Wrapper>
        <CustomDialogHeading>
          <Translate msg={"behavioralConnectLyra.title"} />
        </CustomDialogHeading>
        <Description>
          <Translate msg={"behavioralConnectLyra.description"} />
        </Description>
        <Action>
          <BehavioralPopupConnectLyraWithApi />
        </Action>
      </Wrapper>
    </ConnectLyraPopup>
  );
};
